import {API_URL} from "../config";
import axios from "../utils/axios";

class AuditLogRepository
{
    getAll(filter) {
        return axios.get(API_URL + "/AuditLog/List?", { params: filter });
    }

    export(filter) {
        return axios.get(API_URL + "/AuditLog/Export?",
            {
                params: filter,
                responseType: 'blob'
            });
    }
}

export default AuditLogRepository;